module.exports = __webpack_public_path__ + "img/content_create.b8b5e77b.png";